export default __webpack_public_path__ + "static/lozenge-icon-do-dark-5c05c531618879e6fd356d42e98123049f8437343f1de6da36fc948bc547fb23.png";